export enum ProjectTypeEnum {
  ONE_TIME = 'one_time',
  CYCLICAL = 'cyclical',
}
export const PROJECT_TYPE_OPTIONS = [
  { label: 'Единоразовый', value: ProjectTypeEnum.ONE_TIME },
  { label: 'Цикличный', value: ProjectTypeEnum.CYCLICAL },
]

export enum ProjectStatusEnum {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
  PAUSED = 'paused',
  CANCELED = 'canceled',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}
export const PROJECT_STATUS_OPTIONS = [
  { label: 'Черновик', value: ProjectStatusEnum.DRAFT },
  { label: 'Опубликован', value: ProjectStatusEnum.PUBLISHED },
  { label: 'Снят с публикации', value: ProjectStatusEnum.UNPUBLISHED },
  { label: 'На паузе', value: ProjectStatusEnum.PAUSED },
  { label: 'Отменен', value: ProjectStatusEnum.CANCELED },
  { label: 'Закрыт', value: ProjectStatusEnum.CLOSED },
  { label: 'Архив', value: ProjectStatusEnum.ARCHIVED },
]

export function getProjectStatusLabel(value: string | null | undefined): string {
  const raw = (value ?? '').trim()
  if (!raw) return ''
  const option = PROJECT_STATUS_OPTIONS.find((item) => item.value === raw)
  return option?.label ?? raw
}

export enum ProjectStageEnum {
  IDEA = '1',
  PLANNING = '2',
  IMPLEMENTATION = '3',
  TESTING = '4',
  COMPLETED = '5',
  PHASE_SIX = '6',
}
